module.exports = __webpack_public_path__ + "static/design-1-5383b5c0b521ffd12493b80e6fce00e6.png";